import { BCMSStateManagerCRUD, useModel } from "bcms-react";
import LoginPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/LoginPage";

export default function CapturePasswordEntered(props) {
    // initalize a new BCMSStateManagerCRUD instance using the default page data
    // updating the modal property
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "userID" ], "georgew")
    .update([ "password" ], "12345678")
    .submit();

    return <LoginPage data={ data } />
}
